import {Route} from "react-router-dom";
import PrivateRoute from "context/PrivateRoute";
import MainDeviceConfiguration from "./MainDeviceConfiguration";
import ViewGroupsProfiles from "./ViewGroupsProfiles";
import ViewProfilesShips from "./ViewProfilesShips";
import ViewProfilesAlerts from "./ViewProfilesAlerts";
import ViewProfilesSensors from "./ViewProfilesSensors";
import FormAlertSetup from "./alerts/FormAlertSetup";
import ViewShipping from "./ViewShipping";

// prettier-ignore
const RoutesDevicesConfiguration = () => {

       return (
              <>
                     <Route path="device-configuration" element={<PrivateRoute role="admin"><MainDeviceConfiguration /></PrivateRoute>} />
                     <Route path="device-configuration/groups-profiles"
                            element={<PrivateRoute role="admin"><ViewGroupsProfiles /></PrivateRoute>} />
                     <Route path="device-configuration/measures"
                            element={<PrivateRoute role="admin"><ViewProfilesShips /></PrivateRoute>} />
                     <Route path="device-configuration/sensors"
                            element={<PrivateRoute role="admin"><ViewProfilesSensors /></PrivateRoute>} />
                     <Route path="device-configuration/alerts"
                            element={<PrivateRoute role="admin"><ViewProfilesAlerts /></PrivateRoute>} />
                     <Route path="device-configuration/alert/setup/:id"
                            element={<PrivateRoute role="admin"><FormAlertSetup /></PrivateRoute>} />
                     <Route path="device-configuration/shipping/"
                            element={<PrivateRoute role="admin"><ViewShipping /></PrivateRoute>} />
              </>
       )
}
export default RoutesDevicesConfiguration;
